import React, { useState, useEffect } from 'react';
import { useParams, ScrollRestoration } from 'react-router-dom';
// Config
import { POSTER_SIZE, BACKDROP_SIZE, IMAGE_BASE_URL } from '../config';
import API from '../API'
// Components
import Header from './Header';
import Thumb from './Thumb';
import Knoppie from './Knoppie';
import InfoButton from './InfoButton'
import ClubHeader from './ClubHeader';
import SearchBar from './SearchBar';
import ButtonGrid from './ButtonGrid'
import List from './List'

// Hook
import useAuth from '../hooks/useAuth';
import { useUserListFetch } from '../hooks/useUserListFetch';
// Image
import NoImage from '../images/no-image.png';
import Grid from './Grid';


let renderCount = 0

const UsersList =  () => {
  const auth = useAuth();
  const{id}=useParams()
  console.log(id)
  const [includeSwitch, setIncludeSwitch] = useState(false)
  
 
  const {userState,userLoading,userError,setUserSearchValue,setUserIncludeInactive,setUserLoading,setUserTrigger} = useUserListFetch(id);
  
  const handleScroll = () =>{
    const element = document.getElementById(id?id:"")
    console.log("handlescroll is getrigger")
    console.log(element)
    if(element){
      element.scrollIntoView({
       
      })

    }

  }


  const handleClick= async (e)=>{

      try {

        // eslint-disable-next-line no-restricted-globals
        const confirmation = confirm("Are you sure you want to Delete this user? This action cannot be overturned!")
        if(confirmation){
        setUserTrigger(true)

        console.log("Sukses, die user gaan delete word hier")
        await API.deleteUser(e.target.id,auth.auth.accessToken)
        
      }else{
        return
      }
      } catch (error) {
          console.log(error)
      }
          
      console.log("gekliek op" + e.target.id)
      console.log(auth.auth.user.username)

  }

  useEffect(()=>{

    if(!userLoading){
      handleScroll()
    }

  },[userState])

  const username = auth.auth.user.username
  
  const access = auth.auth.user.userRole
  // console.log(besluit.besluit[0].besluit)
  console.log(userState)
 
  renderCount++
  return (
    <>
     
      <Header username={username} role={access} destination={'./'}></Header>
      
      

        {/* <h1>RenderCount {renderCount/2}</h1> */}

        <div className='ListHead'>
        <SearchBar key={1}  setSearchValue={setUserSearchValue}></SearchBar>
            <ButtonGrid>
            <Knoppie
            text={'Show All'}
            clickable={true}
           dropdown={true}
            switchOn={includeSwitch === true}
            callback={() => {
              setUserIncludeInactive(true)
              setIncludeSwitch(true)
            }}
            />
            <Knoppie
            text={'Show Active Only'}
            clickable={true}
            dropdown={true}
            switchOn={includeSwitch === false}
            callback={() => {
              setUserIncludeInactive(false)
              setIncludeSwitch(false)
            }}
            />
          </ButtonGrid>
        </div>

        {userError?"error":""}
              <List header={`Users ${userState.users.length}` }
                destination={''}>

        {/* <div className='SingleEmployee'>
        <Thumb
                 
           image={NoImage}      
          name={"Name"}
          area={"Surname"}
          phone={'Phone'}
        
          
        >
            <div></div>
            <div>Actions</div>
        </Thumb>

        </div> */}
        
        
        
        {userLoading?<h1>...Loading</h1>:""}
        
        {userState.users.map(user => (
         
         <>
         <div className='SingleEmployee'>
          <Thumb
            // onclick={setElementid(employee._id)}
            key={user._id}
            clickable={true}
            image={user.avatarUrl?user.avatarUrl:NoImage}
            name={user.username}
            area={user.surname}
            root={"User"}
            phone={user.phone}
            id={user._id}
            players={""}
            points={user.points?user.points:0}
            employeeid={user._id}
        
            >
              <div>{user.userRole}</div>
           <Knoppie
            clickable={true}
            text={"Delete"}
            destination={'../UsersList'}
            employeeid={user._id}
            callback={handleClick}
            >

            </Knoppie> 

            

            </Thumb>
            

            </div>
            </>
            
          ))}
          

          </List>     
          
    </>
  );
};

export default UsersList;

